import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findPorProgramaUniversidadId(programaUniversidadId, opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos(`inscripcion-programa-universidad-reporte/programa-universidad/${programaUniversidadId}`),
      opciones,
    );
  },
};
